import { Get } from "../../../../../Request";

export const GetData = async (limit = 15, page = null) => {
  return await Get({
    url: "/dashboard/admin",
  }).then(data => {
    return data;
  });
};

export const getOrderDetails = async request => {
  return await Get({
    url: "/order/order_details",
    data: request,
  }).then(data => {
    return data;
  });
};
